import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-2",
    style: { "line-height": "24px" }
};
const _hoisted_2 = { class: "form-text text-muted" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_form_item = _resolveComponent("el-form-item");
    return (_openBlock(), _createBlock(_component_el_form_item, {
        label: _ctx.label,
        required: _ctx.required,
        prop: _ctx.prop,
        rules: _ctx.rules,
        "show-message": false,
        class: _normalizeClass({ 'with-description': _ctx.description })
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default"),
            (_ctx.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("small", _hoisted_2, _toDisplayString(_ctx.description), 1 /* TEXT */)
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["label", "required", "prop", "rules", "class"]));
}
